<template>
  <unroll-element
    :title="stringified_dict(metavariables_poid)"
    :available="roc_curve_instantiated"
    :start_opened="roc_curve_instantiated"
  >
    <div v-if="roc_curve_instantiated">
      <roc-chart :project_id="project_id" :poid="roc_curve_poid" />
    </div>
  </unroll-element>
</template>

<script>
import _ from 'lodash'

import {
  brick_mixin,
  subscription_mixin,
  metavariables_tracking_info_mixin,
  brick_generic_modelgenerator_tracking_info_mixin,
} from '@/components/mixin.js'

import UnrollElement from './unroll_element.vue'
import RocChart from '@/components/roc_chart.vue'

// *****************************************************************************

export default {
  name: 'BrickGenericModelgeneratorSubcomponentRoc',
  components: { UnrollElement, RocChart },
  mixins: [
    brick_mixin,
    subscription_mixin,
    metavariables_tracking_info_mixin,
    brick_generic_modelgenerator_tracking_info_mixin,
  ],
  props: ['brick_id', 'project_id', 'metavariables_poid'],
  computed: {
    roc_curve_poid() {
      let res = this.metavariables_tracking_info.roc_curve_poid || -1
      return res
    },
    roc_curve_instantiated() {
      let res = this.fetch_poid_status(
        `roc_curve_instantiated_${this.roc_curve_poid}`,
        this.roc_curve_poid
      )
      return res
    },
  },
  watch: {
    roc_curve_instantiated: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          if (nv) {
            this.$emit('is_instantiated')
          }
        }
      },
    },
  },
}
</script>
